import axios from 'axios';
import { takeEvery, call, put } from 'redux-saga/effects';

import {
    FETCH_EXERCISE_EQUIPMENTS,
    FETCH_EXERCISE_EQUIPMENTS_FETCHING,
    FETCH_EXERCISE_EQUIPMENTS_SUCCESS,
    FETCH_EXERCISE_EQUIPMENTS_FAIL
} from '../actions/ActionTypes';

export function* fetchExerciseEquipments() {
    try {
        yield put({
            type: FETCH_EXERCISE_EQUIPMENTS_FETCHING
        });

        const url = '/web-data/exercises/exerciseToEquipments.json';
        const response = yield call(axios.get, url, { baseURL: '/' });

        yield put({
            type: FETCH_EXERCISE_EQUIPMENTS_SUCCESS,
            exerciseEquimentsData: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_EXERCISE_EQUIPMENTS_FAIL,
            exerciseEquimentsData: {}
        });
    }
}

export const exerciseEquipmentsSagas = [takeEvery(FETCH_EXERCISE_EQUIPMENTS, fetchExerciseEquipments)];
